import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <Link to="/" className="logo">
              <div className="logo-badge">
                <svg viewBox="0 0 12 12"><polygon points="6,1 11,9 1,9"/></svg>
              </div>
              AMAVIX TECH
            </Link>
            <p className="footer-text">
              Engineering the future of digital products with precision and purpose.
            </p>
          </div>
          
          <div className="footer-grid">
            <div className="footer-col">
              <h4 className="footer-label">Navigation</h4>
              <ul className="footer-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/projects">Projects</Link></li>
                <li><Link to="/process">Process</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>
            <div className="footer-col">
              <h4 className="footer-label">Socials</h4>
              <ul className="footer-links">
                <li><a href="https://www.linkedin.com" target="_blank" rel="noreferrer">LinkedIn</a></li>
                <li><a href="https://x.com" target="_blank" rel="noreferrer">Twitter</a></li>
                <li><a href="https://github.com" target="_blank" rel="noreferrer">GitHub</a></li>
              </ul>
            </div>
            <div className="footer-col">
              <h4 className="footer-label">Connect</h4>
              <ul className="footer-links">
                <li><a href="mailto:hello@amavix.tech">hello@amavix.tech</a></li>
                <li><a href="tel:+15550000000">+1 (555) 000-0000</a></li>
                <li><span className="footer-info">Remote / Worldwide</span></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-legal">
            <span>&copy; 2025 Amavix Tech. Built with precision.</span>
          </div>
          <div className="footer-status">
            <span className="status-dot"></span>
            System Status: Operational
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
